import Attestation, { AttestationStatuts }  from '@/generated/classes/Attestation';
export default class AttestationExtend extends Attestation {
  constructor() {
    super();
  }

  public static statusLabel(value: AttestationStatuts): string {
    if (value == AttestationStatuts.NON_DEMANDE) {
      return 'Demande à faire';
    }
    else if (value == AttestationStatuts.DEMANDE) {
      return 'Demandée';
    }
    else if (value == AttestationStatuts.PRIS_EN_CHARGE) {
      return 'Prise en charge';
    }
    else if (value == AttestationStatuts.REFUSE) {
      return 'Régularisation en cours';
    }
    else if (value == AttestationStatuts.OBTENU) {
      return 'Obtenue';
    }
    return 'N/A';
  }
}
